import React from 'react';
import { Link } from 'react-router-dom';

const BlogCard = ({ blog }) => {
  return (
    <div className="group">
      <div className='p-6 rounded-lg' style={{ boxShadow: '0px 1px 40px 0px rgba(0, 0, 0, 0.05)'}}>
        <div className="aspect-h-1 aspect-w-1 w-full overflow-hidden rounded-lg bg-gray-200 xl:aspect-h-8 xl:aspect-w-7" style={{height: "300px"}}>
          <img src={blog.fotoBlog} alt={blog.titulo} className="h-full w-full object-cover object-center group-hover:opacity-75" />
        </div>
        <div className='my-2'>
          <span className='bg-[#C7DDDA] rounded-3xl text-xs font-bold px-3 py-1'>Category</span>
        </div>
        <h3 className="mt-4 mb-2 text-lg text-gray-900 font-bold truncate">{blog.titulo}</h3>
        <p className="text-sm font-medium text-gray-900 overflow-hidden text-ellipsis h-16">{blog.descripcion}</p> 
        <div className="mt-4">
          <Link to={`/Blog/${blog.blogId}`} className="text-sm font-bold text-[#475467] hover:underline">Read More</Link>
        </div>
      </div>
    </div>
  );
};

export default BlogCard;
